/**
 * Оговорки.
 *
 * Показываются целиком и всегда, без «подробнее». Оговорка, о которой ответ
 * забыл, — это неверный ответ: «Shorts не в расчёте» меняет прочтение любой
 * цифры про просмотры, потому что Shorts дают больше половины просмотров
 * канала. Сворачивать их нельзя.
 */

export function Disclosures({ items }: { items: string[] }) {
  if (items.length === 0) return null;
  return (
    <ul className="disclosures">
      {items.map((text) => (
        <li key={text}>{text}</li>
      ))}
    </ul>
  );
}
